<div fxShow="true" fxHide.lt-md="true">
  <button mat-icon-button (click)="openDashboard()" title="Estadística">
    <mat-icon>bar_chart</mat-icon>
  </button>

  <button
    mat-icon-button
    *ngIf="isLoggedIn()"
    routerLink="/explorer-item-new"
    title="Nueva observación"
  >
    <mat-icon>add</mat-icon>
  </button>

  <button mat-button routerLink="inicio" class="button-small">INICIO</button>

  <button mat-button [matMenuTriggerFor]="nosotros" class="button-small">
    NOSOTROS<mat-icon class="icon-button-small">expand_more</mat-icon>
  </button>
  <mat-menu #nosotros="matMenu">
    <button class="button-small" mat-menu-item routerLink="nosotros">
      ACERCA DE
    </button>
    <button class="button-small" mat-menu-item routerLink="guardianes">
      GUARDIANES
    </button>
  </mat-menu>

  <button
    mat-button
    (click)="fnGoToView('observaciones')"
    style="font-weight: 700; color: #fffb00"
    class="button-small"
  >
    EXPLORA
    <mat-icon class="icon-button-small">search</mat-icon>
  </button>

  <button
    *ngIf="isLoggedIn()"
    mat-button
    (click)="fnGoToView('observaciones', true)"
    style="font-weight: 700; color: #fffb00"
    class="button-small"
  >
    MIS OBSERVACIONES
    <mat-icon class="icon-button-small">search</mat-icon>
  </button>

  <button mat-button [matMenuTriggerFor]="catalogo" class="button-small">
    CATÁLOGO<mat-icon class="icon-button-small">expand_more</mat-icon>
  </button>
  <mat-menu #catalogo="matMenu">
    <button class="button-small" mat-menu-item routerLink="catalogo-info">
      ACERCA DE
    </button>
    <button class="button-small" mat-menu-item routerLink="catalogo">
      CATÁLOGO
    </button>
    <button class="button-small" mat-menu-item routerLink="publicaciones">
      PUBLICACIONES
    </button>
    <!-- <button class="button-small" mat-menu-item routerLink="lista-qr">
      LISTA DE QR's
    </button> -->
  </mat-menu>

  <button mat-button [matMenuTriggerFor]="mas" class="button-small">
    MÁS<mat-icon class="icon-button-small">expand_more</mat-icon>
  </button>
  <mat-menu #mas="matMenu">
    <button
      class="button-small"
      mat-menu-item
      [matMenuTriggerFor]="conservacion"
    >
      SÚMATE A LA CONSERVACIÓN
    </button>
    <button class="button-small" mat-menu-item routerLink="appmovil">
      VARSCOUT
    </button>
    <button class="button-small" mat-menu-item routerLink="contacto">
      CONTACTO
    </button>
  </mat-menu>

  <mat-menu #conservacion="matMenu">
    <button class="button-small" mat-menu-item routerLink="consume-miski-papa">
      CONSUME MISKI PAPA
    </button>
    <button class="button-small" mat-menu-item routerLink="registra-variedades">
      REGISTRA TUS VARIEDADES
    </button>
  </mat-menu>

  <button
    class="button-small m-r-20 hidden-sm-up"
    mat-raised-button
    color="warn"
    (click)="login()"
    *ngIf="!isLoggedIn()"
  >
    Acceder
  </button>

  <button
    mat-stroked-button
    class="button-small"
    [matMenuTriggerFor]="profile"
    *ngIf="isLoggedIn()"
  >
    <mat-icon class="icon-button-small">account_circle</mat-icon>
    {{ getUsername() }}
  </button>
</div>

<mat-menu #profile="matMenu" class="mymegamenu">
  <button class="button-small" mat-menu-item routerLink="tablero/home">
    Tableros
  </button>

  <mat-divider *ngIf="fnIsRole('ADMIN')"></mat-divider>
  <button
    class="button-small"
    *ngIf="fnIsRole('ADMIN')"
    mat-menu-item
    (click)="fnGoToView('tablero/variety-list-edit')"
  >
    <!-- routerLink="tablero/variety-list-edit" -->
    Editar variedades
  </button>
  <button
    class="button-small"
    *ngIf="fnIsRole('ADMIN')"
    mat-menu-item
    (click)="fnGoToView('catalogo-item-new')"
  >
    <!-- routerLink="tablero" -->
    Agregar variedades
  </button>
  <button
    class="button-small"
    *ngIf="fnIsRole('ADMIN')"
    mat-menu-item
    (click)="fnGoToView('catalogo-import')"
  >
    <!-- routerLink="catalogo-import" -->
    Importar variedades
  </button>

  <mat-divider></mat-divider>
  <button
    class="button-small"
    class="button-small"
    mat-menu-item
    (click)="fnGoToView('tablero/explorer-list-edit')"
  >
    <!-- routerLink="tablero/explorer-list-edit" -->
    Editar observaciones
  </button>
  <button
    class="button-small"
    class="button-small"
    mat-menu-item
    (click)="fnGoToView('/explorer-item-new')"
  >
    <!-- routerLink="/explorer-item-new"  -->
    Agregar observaciones
  </button>
  <button
    *ngIf="fnIsRole('ADMIN')"
    class="button-small"
    mat-menu-item
    (click)="fnGoToView('explorer-import')"
  >
    <!--  routerLink="explorer-import" -->
    Importar observaciones
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item class="button-small" (click)="fnGoToView('perfil')">
    <!-- routerLink="perfil" -->
    <!-- (click)="fnGoToView('perfil')" -->
    Perfil
  </button>
  <button
    mat-menu-item
    class="button-small"
    (click)="fnGoToView('configurar-cuenta')"
  >
    <!-- routerLink="configurar-cuenta" -->
    Configuración de cuenta
  </button>
  <mat-divider></mat-divider>

  <button mat-menu-item class="button-small" (click)="logOut()">Salir</button>
</mat-menu>

<button
  mat-icon-button
  class="button-small"
  [matMenuTriggerFor]="menu"
  fxShow="true"
  fxHide.gt-sm
>
  <mat-icon class="icon-button-small">menu</mat-icon>
</button>
<mat-menu #menu="matMenu" xPosition="before">
  <a mat-menu-item routerLink="inicio">INICIO</a>
  <hr />
  <p style="text-align: left; font-size: small; padding-left: 17px">
    NOSOTROS.
  </p>
  <button mat-menu-item routerLink="nosotros">ACERCA DE</button>
  <button mat-menu-item routerLink="guardianes">GUARDIANES</button>
  <hr />
  <button mat-menu-item routerLink="observaciones">EXPLORA</button>
  <button mat-menu-item routerLink="observaciones-propias">
    MIS OBSERVACIONES
  </button>

  <hr />
  <p style="text-align: left; font-size: small; padding-left: 17px">
    CATÁLOGO.
  </p>
  <button mat-menu-item routerLink="catalogo-info">ACERCA DE</button>
  <button mat-menu-item routerLink="catalogo">CATÁLOGO</button>
  <button mat-menu-item routerLink="publicaciones">PUBLICACIONES</button>
  <hr />
  <p style="text-align: left; font-size: small; padding-left: 17px">
    SÚMATE A LA CONSERVACIÓN.
  </p>
  <button mat-menu-item routerLink="consume-miski-papa">
    CONSUME MISKI PAPA
  </button>
  <button mat-menu-item routerLink="registra-variedades">
    REGISTRA TUS VARIEDADES
  </button>
  <hr />
  <button mat-menu-item routerLink="appmovil">VARSCOUT</button>
  <hr />
  <button mat-menu-item routerLink="contacto">CONTACTO</button>
  <hr />
  <button mat-menu-item routerLink="tablero/home">TABLEROS</button>
</mat-menu>
